import { CouponTypeEnum } from 'common/enums/CouponTypeEnum'
import { usePayment } from 'publisher/store'
import { getCheckedCoupon } from 'publisher/store/payment/paymentSelectors'
import { useOfferPricing } from 'src/publisher/hooks/use-offer-pricing'

/**
 * @returns final payment amount for selected products (digital and physical) and shipping cost combined in cents
 */
export const useFinalAmount = () => {
  const coupon = usePayment(getCheckedCoupon)

  const {
    selectedOfferPricing,
    physicalBumpOfferPricing,
    digitalBumpOfferPricing,
  } = useOfferPricing()

  const selectedBumpPricing =
    physicalBumpOfferPricing ?? digitalBumpOfferPricing

  const totalGrossAmount =
    (selectedOfferPricing?.grossAmount ?? 0) +
    (selectedBumpPricing?.grossAmount ?? 0)

  const isFullyPaidByCoupon =
    (coupon?.discountType === CouponTypeEnum.Percent &&
      coupon.discountAmount === 100) ||
    (coupon?.discountType === CouponTypeEnum.Fixed &&
      coupon.discountAmount >= (selectedOfferPricing?.originalAmount ?? 0))

  if (isFullyPaidByCoupon) {
    return 0
  }

  return totalGrossAmount
}
